import React from 'react'
import R from '../ramda'
import './FilterDescr.css'

function FilterDescr(props) {
  let { filterDescr, onClearFilter, onClearFilters } = props
  let emptyFilterDescr = R.isEmpty(filterDescr)
  return (
    <div className="FilterDescr">
      <div className="FilterDescr-label">Filtri Attivi:</div>
      <div className="FilterDescr-filters">
        {emptyFilterDescr ? (
          <p className="FilterDescr-nofilters"> Non ci sono filtri selezionati </p>
        ) : (
          R.compose(
            R.values,
            R.mapObjIndexed((descr, key) => (
              <span key={key}>
                <button
                  className="FilterDescr-item btn"
                  title={'• ' + descr.join('\n• ')}
                  onClick={() => onClearFilter(key)}
                >
                  {descr.join(', ')}
                </button>
              </span>
            )),
          )(filterDescr)
        )}
      </div>
      <div className="FilterDescr-clear">
        <button
          className="btn FilterDescr-clear-btn"
          onClick={() => onClearFilters()}
          disabled={emptyFilterDescr}
        >
          Azzera filtri
        </button>
      </div>
    </div>
  )
}

export default FilterDescr



// WEBPACK FOOTER //
// ./src/filters/FilterDescr.js